import * as z from "zod/v4";

const GetBillOfMaterialsTagsInput_ = z.object({
  search: z.string().optional(),
});
export const GetBillOfMaterialsTagsInput: z.ZodType<GetBillOfMaterialsTagsInput> =
  GetBillOfMaterialsTagsInput_;
export interface GetBillOfMaterialsTagsInput
  extends z.infer<typeof GetBillOfMaterialsTagsInput_> {}

export const getBillOfMaterialsTags = {
  name: "getBillOfMaterialsTags" as const,
  input: GetBillOfMaterialsTagsInput,
  output: z.object({ tags: z.array(z.string()) }),
};
